import { Theme } from '@mui/material';
import {
  Coins,
  Eye,
  FirstAidKit,
  HeartStraight,
  Prohibit,
} from '@phosphor-icons/react';

import { mapBenefitLookupCodes } from 'theSource/utils';
import { Benefit, BenefitCategoryNullable } from '../types';

export const disableSurveysInBenefits = (benefits: Benefit[]): Benefit[] => {
  return benefits.map((benefit) => {
    if (
      benefit.benefitLookupCode.startsWith('survey') &&
      !benefit.benefitLookupCode.endsWith('_additional_benefits')
    ) {
      benefit.disabled = true;
    }
    return benefit;
  });
};

export const getBenefitsCategories = (
  theme: Theme
): BenefitCategoryNullable[] => {
  return [
    {
      name: 'medical',
      label: 'medical',
      icon: (
        <FirstAidKit
          size={32}
          color={theme.palette.primary.main}
          weight="duotone"
        />
      ),
      benefits: mapBenefitLookupCodes([]),
    },
    {
      name: 'healthAndWellness',
      label: 'healthAndWellness',
      icon: (
        <Eye size={32} color={theme.palette.primary.main} weight="duotone" />
      ),
      benefits: mapBenefitLookupCodes([]),
    },
    {
      name: 'wealthAndFinancial',
      label: 'wealthAndFinancial',
      icon: (
        <Coins size={32} color={theme.palette.primary.main} weight="duotone" />
      ),
      benefits: mapBenefitLookupCodes([]),
    },
    {
      name: 'lifestyle',
      label: 'lifestyle',
      icon: (
        <HeartStraight
          size={32}
          color={theme.palette.primary.main}
          weight="duotone"
        />
      ),
      benefits: mapBenefitLookupCodes([]),
    },
    {
      name: 'declined',
      disabled: true,
      label: 'declined',
      icon: <Prohibit size={32} color={theme.palette.grey[400]} />,
      benefits: mapBenefitLookupCodes([]),
    },
  ];
};
